import { formatting } from "@/lib/formatting";
import { TeamGoalField } from "@/types";

export const teamGoals = {
  // Submits must divide evenly across staffers (FE enforces in the dialog).
  // Other counts round up so per-staffer goals match the team total / N.
  perStafferGoal: (
    teamGoal: number,
    numStaffers: number,
    field: TeamGoalField,
  ): number => {
    if (numStaffers <= 0) return 0;
    if (field === TeamGoalField.SUBMITS) return teamGoal / numStaffers;
    if (field === TeamGoalField.REVENUE) {
      // Round up to nearest $1,000 so the denominator never undershoots.
      return Math.ceil(teamGoal / numStaffers / 1000) * 1000;
    }
    return Math.ceil(teamGoal / numStaffers);
  },

  // Weekly view: a month is treated as 4 weeks. Ceil so the weekly target never
  // undershoots; revenue rounds up to the nearest $1,000 like the monthly goal.
  weeklyGoal: (monthlyGoal: number, field: TeamGoalField): number => {
    if (field === TeamGoalField.REVENUE) {
      return Math.ceil(monthlyGoal / 4 / 1000) * 1000;
    }
    return Math.ceil(monthlyGoal / 4);
  },

  // Goal denominator: "$45K" / "$1.2M", always rounded up.
  formatRevenueGoal: (amount: number): string =>
    formatting.compactUsd(amount, { roundUp: true }),

  // Actual numerator: "$45.3K" — one decimal so partial progress is visible
  // against the rounded-up denominator.
  formatRevenueActual: (amount: number): string =>
    formatting.compactUsd(amount, { decimals: 1 }),

  // Floor(value / goal). No cap — 2x goal = 2 stars, 3x = 3, etc.
  starCount: (value: number, goal: number): number => {
    if (goal <= 0) return 0;
    return Math.floor(value / goal);
  },

  // Next value at or above the entry that divides evenly across staffers.
  nextDivisibleSubmits: (value: number, numStaffers: number): number => {
    if (numStaffers <= 0) return value;
    return Math.ceil(value / numStaffers) * numStaffers;
  },
};
